module.exports = __webpack_public_path__ + "static/media/SaintJohntheEvangelistSchoolDanvers.94f8f156.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/SaintJohntheEvangelistSchoolDanvers.jpeg
// module id = 681
// module chunks = 0